import { Box } from '@mui/material';
import { ToolsListing } from '../../../components/custom';
import { LayoutBase } from '../../../layouts';
import { VMenu } from '../../../components/shared';
import { useParams } from 'react-router-dom';

export default function Risrot() {
    const url = useParams();

    return(
        <LayoutBase
            title='Relatórios de Inspeção de Segurança Rotineiro (RISROT)'
            tollBar={
                <ToolsListing 
                    textoBotaoNovo='Novo'
                    showNewButton
                    showBackButton
                    mostrarInputBusca
                    // textoDaBusca={searchText}
                    // onClickNew={() => handleNew()}
                    // aoMudarTextoBusca={texto => setSearchText(texto)}
                />
            }
        >
            <Box>
                <VMenu id={url.id}/>
            </Box>

        </LayoutBase>
    );
}